/**
 * The Vault's hold rule, above the cards (partner feedback 2026-10-01, copy
 * confirmed as is). The hours and the percentage mirror the operator's
 * current auto-sell settings; the iframe doesn't receive those, so a change
 * there means changing this copy too.
 */
export function VaultHint() {
  return (
    <p
      data-co-component="MyPacksVaultHint"
      className="mx-auto mb-5 max-w-[640px] text-[12px] leading-[16px] text-[var(--co-MyPacksVaultHint-color,#6D707C)]"
    >
      You can hold cards for up to 24 hours. If cards are not shipped, they will be sold for 100% market value.
    </p>
  );
}
